import { render, staticRenderFns } from "./create-workflow-form.vue?vue&type=template&id=68e564f9&scoped=true&"
import script from "./create-workflow-form.vue?vue&type=script&lang=js&"
export * from "./create-workflow-form.vue?vue&type=script&lang=js&"
import style0 from "./create-workflow-form.vue?vue&type=style&index=0&id=68e564f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e564f9",
  null
  
)

export default component.exports